<i18n src="../langset.json"></i18n>
<template>
  <ComDialog
    :isShow="dialogVisible"
    :width="500"
    :title="t('批量搜索')+selectedFieldLabel"
    alignCenter
    @close="handleClose"
  >
    <el-form :model="formData">
      <!-- <el-form-item label="批量筛选字段" prop="selectedOption">
        <el-select v-model="formData.selectedOption" filter placeholder="请选择">
          <el-option
            v-for="(item,index) in filterOptions"
            :key="index"
            :label="item.label"
            :value="item.prop"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item prop="paramsStr">
        <el-input
          type="textarea"
          :rows="10"
          :placeholder="placeholderStr"
          v-model="formData.paramsStr"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <div class="dialog-footer">
          <el-button type="primary" @click="search">{{ t("搜索") }}</el-button>
        </div>
      </el-form-item>
    </el-form>
  </ComDialog>
</template>
<script setup>
import { ref, defineExpose, defineEmits, computed } from "vue";
import ComDialog from "@/components/comDialog/index.vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const dialogVisible = ref(false);
const formData = ref({ selectedOption: "", paramsStr: "" });
const selectedFieldLabel = ref("");
let filterOptions = ref([]);
const emit = defineEmits(["batchParams"]);
const placeholderStr = computed(() => {
  const str = selectedFieldLabel.value || "";
  return str ? t("批量搜索提示").replaceAll('nnnn', '【' + str + '】') : "";
});
const open = (filterField,fieldValue) => {
  selectedFieldLabel.value = filterField.label;
  formData.value = { selectedOption: filterField.prop, paramsStr: fieldValue||"" };
  dialogVisible.value = true;
};
const handleClose = () => {
  dialogVisible.value = false;
};
const search = () => {
  dialogVisible.value = false;
  const obj = {};
  // 使用正则表达式将所有分隔符（空格、换行、英文逗号、中文逗号）统一替换为英文逗号
  obj[formData.value.selectedOption] = formData.value.paramsStr
    .replace(/[\s\r\n，,]+/g, ',');
  emit("batchParams", obj);
};
defineExpose({ open });
</script>
  <style lang="scss" scoped>
.dialog-footer {
  text-align: center;
  width: 100%;
  .el-button {
    min-width: 120px;
  }
}
</style>